/* eslint-disable */
import { mapState } from 'vuex';
import { DateFormatMixin } from '@/mixins/Booking/DateFormatMixin';
import { TimeFormatMixin } from '@/mixins/Booking/TimeFormatMixin';
import moment from 'moment-timezone'

export const BookingPaymentDateTimeMixin = {
    mixins: [DateFormatMixin, TimeFormatMixin],
    computed: {
        ...mapState('BookingPayment', [
            'bookingPayment'
        ]),
        startUtc(){
            return !!this.bookingPayment ? this.bookingPayment.startUtc : ''
        },
        timeZoneId(){
            return !!this.bookingPayment ? this.bookingPayment.timeZoneId : ''
        },
        formattedStartUtc() {
            if (!!this.startUtc) {
                return moment.utc(this.startUtc).clone().tz(this.timeZoneId)
            }
        },
        formattedStartDay(){ 
            return this.formattedStartUtc ? this.formattedStartUtc.format('dddd') : "";
        },
        formattedStartDate(){ 
            return this.formattedStartUtc ? this.formattedStartUtc.format(this.momentJSDateFormat) : "";
        },
        formattedStartTime() {
            return this.formattedStartUtc ? this.formattedStartUtc.format(this.momentJSTimeFormat) : "";
        }
    }
}
